import { useState } from "react"
import { deposit } from "../../core/web3";
import { NotificationManager } from 'react-notifications';

const BuyCoinsForm = ({ balanceCallback, goBack }) => {
	const [amount, setAmount] = useState()

	return (
		<form
			onSubmit={ async (e) => {
				e.preventDefault()
				let res = await deposit(amount);
				balanceCallback();
			}}
		>
			<div className="x-between">
				<h2 className="capitalize font-bold  text-lg sm:text-xl lg:text-3xl text-white">
					Buy coins
				</h2>

				<button
					onClick={goBack}
					className="px-4 hover:bg-gray-100 py-1 flex align-middle bg-white rounded-full font-semibold"
				>
					<span className="my-auto mr-1">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							className="h-4 w-4"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
							strokeWidth={2.5}
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								d="M15 19l-7-7 7-7"
							/>
						</svg>
					</span>
					<span>Back</span>
				</button>
			</div>

			<div className="mt-5">
				<label htmlFor="amount" className="text-white text-sm ml-2">
					Amount
				</label>
				<input
					id="amount"
					value={amount}
					type="number"
					autoFocus
					onChange={(e) => setAmount(e.target.value)}
					className="px-3 font-secondary font-semibold py-2 focus:outline-none bg-gray-900 text-gray-200 h-12 w-full block mt-2 border-2 border-amber-500 rounded-lg"
				/>

				<button
					type="submit"
					className="primary-btn from-green-500 to-green-700 hover:from-green-700 mt-8"
				>
					Buy{amount && <span> {Number(amount).toLocaleString()}</span>}
				</button>
			</div>
		</form>
	)
}

export default BuyCoinsForm
